<div class="flex h-screen bg-canvas font-sans">

  <!-- ================= Sidebar (theme-aware: crisp light / deep dark) ================= -->
  @if (auth.isLoggedIn() && !auth.mustChangePassword()) {
  <aside class="w-72 bg-surface border-r border-slate-200 flex flex-col shrink-0">

    <!-- Brand -->
    <div class="h-16 flex items-center gap-3 px-5 border-b border-slate-200 shrink-0">
      <div class="w-9 h-9 rounded-xl bg-gradient-to-br from-brand to-brand-700 shadow-pop flex items-center justify-center shrink-0">
        <svg xmlns="http://www.w3.org/2000/svg" style="width:18px;height:18px;" class="text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21" />
        </svg>
      </div>
      <div class="leading-tight">
        <div class="font-display text-slate-800 font-bold text-[15px] tracking-tight">Logix AI</div>
        <div class="text-brand text-[11px] font-semibold tracking-wide">ENTERPRISE ERP</div>
      </div>
    </div>

    <nav class="flex-1 overflow-y-auto py-2.5 px-2.5">

      @if (!searching()) {
        <!-- Dashboard (direct link) -->
        <a
          routerLink="/"
          routerLinkActive="bg-brand-50 text-brand"
          [routerLinkActiveOptions]="{ exact: true }"
          class="flex items-center gap-2.5 px-2.5 py-2 rounded-lg text-[13.5px] font-medium text-slate-600 hover:bg-canvas hover:text-slate-800 transition-colors">
          <span class="w-7 h-7 rounded-md bg-brand-50 flex items-center justify-center shrink-0">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-[15px] h-[15px] text-brand" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
            </svg>
          </span>
          Dashboard
        </a>

        <div class="my-3 mx-2 border-t border-slate-100"></div>
      }

      <!-- Favorites (starred modules) -->
      @if (!searching() && favoriteItems().length) {
        <div class="mb-1">
          <div class="px-2.5 py-1 text-[10.5px] font-bold uppercase tracking-[0.08em] text-secondary">Favorites</div>
          @for (f of favoriteItems(); track f.path) {
            <a [routerLink]="f.path" routerLinkActive="bg-brand-50 text-brand"
              class="group flex items-center justify-between gap-2 pl-2.5 pr-1.5 py-[7px] rounded-md text-[13px] text-slate-600 hover:bg-canvas hover:text-slate-800 transition-colors">
              <span class="flex items-center gap-2 min-w-0">
                <svg class="w-3.5 h-3.5 text-warning shrink-0" viewBox="0 0 24 24" fill="currentColor"><path d="M11.48 3.5a.6.6 0 0 1 1.04 0l2.28 4.62 5.1.74a.6.6 0 0 1 .33 1.02l-3.69 3.6.87 5.08a.6.6 0 0 1-.87.63L12 17.3l-4.56 2.4a.6.6 0 0 1-.87-.63l.87-5.08-3.69-3.6a.6.6 0 0 1 .33-1.02l5.1-.74z" /></svg>
                <span class="truncate">{{ f.label }}</span>
              </span>
              <button type="button" (click)="toggleFavorite(f.path, $event)" title="Remove favorite"
                class="opacity-0 group-hover:opacity-100 text-secondary hover:text-danger shrink-0 transition-opacity">
                <svg class="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
              </button>
            </a>
          }
          <div class="my-3 mx-2 border-t border-slate-100"></div>
        </div>
      }

      <!-- Sections -->
      <div class="flex flex-col gap-0.5">
        @for (section of visibleSections(); track section.key) {
          @if (section.key === 'administration') {
            <!-- User Setup: divider before the Administration console (Sir Rashid). -->
            <div class="my-2 border-t border-slate-200 dark:border-slate-700"></div>
          }
          <div>
            <button
              type="button"
              (click)="toggleSection(section.key)"
              class="w-full flex items-center justify-between px-2.5 py-2 rounded-lg text-[13.5px] font-semibold text-slate-700 hover:bg-canvas transition-colors">
              <span class="flex items-center gap-2.5 min-w-0">
                <span class="w-7 h-7 rounded-md flex items-center justify-center shrink-0" [ngClass]="section.iconBg">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-[15px] h-[15px] shrink-0" [ngClass]="section.iconColor" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75">
                    <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="section.icon" />
                  </svg>
                </span>
                <span class="text-left leading-snug">{{ section.label }}</span>
              </span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-3.5 h-3.5 text-secondary shrink-0 transition-transform duration-200"
                [class.rotate-90]="isSectionOpen(section.key)"
                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
              </svg>
            </button>

            @if (isSectionOpen(section.key)) {
              <div class="mt-0.5 mb-1.5 ml-[23px] pl-3 border-l border-slate-200 flex flex-col gap-0.5">
                @for (group of section.groups; track group.key) {
                  <div>
                    <button
                      type="button"
                      (click)="toggleGroup(group.key)"
                      class="w-full flex items-center justify-between gap-2 px-2.5 py-1.5 rounded-md text-[10.5px] font-bold uppercase tracking-[0.08em] text-secondary hover:text-slate-700 transition-colors">
                      <!-- text-left + leading-snug: multi-line labels (e.g. "Cost
                           Centers Group Reports") wrap left-aligned, never centered -->
                      <span class="text-left leading-snug">{{ group.label }}</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="w-2.5 h-2.5 shrink-0 transition-transform duration-200"
                        [class.rotate-90]="isGroupOpen(group.key)"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                      </svg>
                    </button>

                    @if (isGroupOpen(group.key)) {
                      <div class="flex flex-col gap-px mt-0.5 mb-1">
                        @for (item of group.children; track item.path) {
                          <a
                            [routerLink]="item.path"
                            routerLinkActive="bg-brand-50 text-brand font-medium sidebar-active"
                            class="group relative flex items-center justify-between gap-1 pl-3 pr-1.5 py-[7px] rounded-md text-[13px] text-slate-600 hover:bg-canvas hover:text-slate-800 transition-colors">
                            <span class="sidebar-rail absolute left-0 top-1.5 bottom-1.5 w-[3px] rounded-full bg-brand opacity-0 transition-opacity"></span>
                            <span class="text-left leading-snug truncate">{{ item.label }}</span>
                            <button type="button" (click)="toggleFavorite(item.path, $event)"
                              [title]="isFavorite(item.path) ? 'Remove favorite' : 'Add favorite'"
                              class="shrink-0 transition-opacity" [ngClass]="isFavorite(item.path) ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'">
                              <svg class="w-3.5 h-3.5" [attr.fill]="isFavorite(item.path) ? 'currentColor' : 'none'"
                                [ngClass]="isFavorite(item.path) ? 'text-warning' : 'text-secondary hover:text-warning'"
                                viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M11.48 3.5a.6.6 0 0 1 1.04 0l2.28 4.62 5.1.74a.6.6 0 0 1 .33 1.02l-3.69 3.6.87 5.08a.6.6 0 0 1-.87.63L12 17.3l-4.56 2.4a.6.6 0 0 1-.87-.63l.87-5.08-3.69-3.6a.6.6 0 0 1 .33-1.02l5.1-.74z" /></svg>
                            </button>
                          </a>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }

        @if (searching() && visibleSections().length === 0) {
          <div class="px-3 py-6 text-center text-[13px] text-secondary">
            No modules match "{{ navQuery() }}".
          </div>
        }
      </div>
    </nav>

    <!-- Footer -->
    <div class="px-4 py-3 border-t border-slate-200 flex items-center justify-between shrink-0">
      <span class="text-[11px] text-secondary">© 2026 Logix AI ERP</span>
      <span class="text-[10px] font-semibold tracking-wide text-brand bg-brand-50 border border-brand/15 rounded-full px-2 py-0.5">v5 · 2026.07</span>
    </div>
  </aside>
  }

  <!-- ================= Main ================= -->
  <div class="flex-1 flex flex-col overflow-hidden min-w-0">
    @if (auth.isLoggedIn() && !auth.mustChangePassword()) {
    <!-- Balanced 3-zone header: LEFT (context) and RIGHT (actions) both flex-1 so the
         CENTER AI pill stays perfectly centered and nothing crowds the assistant bar. -->
    <header class="h-16 bg-surface border-b border-slate-200 flex items-center gap-4 px-5 shrink-0">

      <!-- LEFT · date only. No page title here: every screen already renders its own H1 in the
           content, so a header title just duplicated it ("two headings"). The breadcrumb was
           dropped too (the sidebar shows the full path). A clean dated calendar block orients the
           user without repeating anything. -->
      <div class="shrink-0 flex items-center gap-2.5">
        <span class="w-9 h-9 rounded-lg bg-brand-50 flex items-center justify-center shrink-0">
          <svg class="w-[18px] h-[18px] text-brand" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0V11.25A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" /></svg>
        </span>
        <div class="leading-tight">
          <div class="text-[13px] font-semibold text-slate-800">{{ today | date:'EEEE' }}</div>
          <div class="text-[11.5px] text-secondary/80 tabular-nums">{{ today | date:'dd MMMM yyyy' }}</div>
        </div>
      </div>

      <!-- CENTER · AI Assistant (hero) — prominent, centered; chat drawer with full ERP knowledge. -->
      <div class="flex-1 flex justify-center px-2">
        <button (click)="assistant.show()"
          class="group w-full max-w-md flex items-center gap-2.5 pl-3.5 pr-4 py-2 rounded-full bg-canvas border border-slate-200 shadow-card hover:border-brand/40 hover:shadow-pop transition-all">
          <app-logix-orb [size]="30" class="shrink-0 group-hover:scale-105 transition-transform" />
          <span class="text-[13px] text-slate-500 group-hover:text-slate-700 transition-colors truncate">Ask Logix AI — any question, any language…</span>
        </button>
      </div>

      <!-- RIGHT · actions: module search, notifications, theme, then the user identity -->
      <div class="shrink-0 flex items-center gap-2 justify-end">
        <button (click)="openPalette()" title="Search modules (Ctrl K)"
          class="shrink-0 w-9 h-9 rounded-lg border border-slate-200 flex items-center justify-center text-secondary hover:text-brand hover:border-brand/40 transition-colors">
          <svg style="width:18px;height:18px;" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.2-5.2m0 0A7.5 7.5 0 1 0 5.2 5.2a7.5 7.5 0 0 0 10.6 10.6z" /></svg>
        </button>
        <app-notification-bell />
        <ui-theme-toggle />
        <div class="h-6 w-px bg-slate-200 shrink-0"></div>
        <div class="flex items-center gap-2.5 min-w-0">
          <div class="w-8 h-8 rounded-full bg-brand-50 border border-brand/20 flex items-center justify-center text-[12px] font-bold text-brand shrink-0">{{ userInitials() }}</div>
          <div class="leading-tight hidden lg:block min-w-0">
            <div class="text-[13px] font-semibold text-slate-800 truncate max-w-[11rem]">{{ auth.currentUser()?.fullName || auth.currentUser()?.userName }}</div>
            <div class="text-[11px] text-secondary truncate max-w-[11rem]">{{ auth.currentUser()?.roleName || 'User' }}</div>
          </div>
          <button (click)="logout()" title="Sign out"
            class="ml-0.5 w-8 h-8 rounded-full border border-slate-200 flex items-center justify-center text-slate-500 hover:text-red-600 hover:border-red-300 transition-colors shrink-0">
            <svg xmlns="http://www.w3.org/2000/svg" style="width:16px;height:16px;" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75" />
            </svg>
          </button>
        </div>
      </div>
    </header>
    }
    <main class="flex-1 overflow-y-auto">
      <router-outlet></router-outlet>
    </main>
  </div>

  <!-- Command palette (Ctrl / Cmd + K) — fuzzy-jump to any module -->
  @if (paletteOpen()) {
    <div class="fixed inset-0 z-[60] bg-slate-900/40 flex items-start justify-center pt-[12vh] px-4" (click)="closePalette()">
      <div class="w-full max-w-xl bg-surface rounded-xl shadow-pop border border-slate-200 overflow-hidden" (click)="$event.stopPropagation()">
        <div class="flex items-center gap-2 px-4 border-b border-slate-200">
          <svg class="w-4 h-4 text-secondary shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.2-5.2m0 0A7.5 7.5 0 1 0 5.2 5.2a7.5 7.5 0 0 0 10.6 10.6z" /></svg>
          <input #paletteInput type="text" [value]="paletteQuery()" (input)="onPaletteQuery($any($event.target).value)"
            placeholder="Search modules…" autocomplete="off"
            class="flex-1 py-3.5 text-sm bg-transparent outline-none border-0" />
          <kbd class="text-[10px] text-secondary border border-slate-200 rounded px-1.5 py-0.5 shrink-0">Esc</kbd>
        </div>
        <div class="max-h-[52vh] overflow-y-auto py-1">
          @for (r of paletteResults(); track r.path; let i = $index) {
            <button type="button" (click)="paletteGo(r.path)" (mouseenter)="paletteIndex.set(i)"
              class="w-full text-left px-4 py-2 flex items-center justify-between gap-3"
              [ngClass]="i === paletteIndex() ? 'bg-brand-50' : 'hover:bg-canvas'">
              <span class="text-[13px] truncate" [ngClass]="i === paletteIndex() ? 'text-brand font-medium' : 'text-slate-800'">{{ r.label }}</span>
              <span class="text-[11px] text-secondary shrink-0 truncate">{{ r.section }} › {{ r.group }}</span>
            </button>
          }
          @if (paletteResults().length === 0) {
            <p class="px-4 py-6 text-center text-[13px] text-secondary">No modules match "{{ paletteQuery() }}".</p>
          }
        </div>
      </div>
    </div>
  }

  <app-assistant-panel #assistant />
</div>
